"use client";

import { useCallback, useState } from "react";
import Particles from "react-tsparticles";
import type { Engine } from "tsparticles-engine";
import { loadSlim } from "tsparticles-slim";

export default function GrinsperHeroHeader() {
	const particlesInit = useCallback(async (engine: Engine) => {
		await loadSlim(engine);
	}, []);

	return (
		<section
			id="grinsper-hero-header"
			className="relative w-full min-h-screen overflow-hidden text-[#111] px-6 py-8 sm:py-8 flex items-center justify-center"
		>
			{/* Partículas flutuantes */}
			<Particles
				className="absolute inset-0 z-0"
				init={particlesInit}
				options={{
					fullScreen: { enable: false },
					fpsLimit: 45,
					detectRetina: false,
					// background: { color: { value: "#F0F4F8" } },
					particles: {
						number: { value: 30, density: { enable: true, area: 800 } },
						color: { value: "#0f172a" },
						shape: { type: "circle" },
						opacity: { value: 0.25 },
						size: { value: { min: 2, max: 4 } },
						move: {
							enable: true,
							direction: "bottom-right",
							speed: 0.6,
							outModes: { default: "out" },
							straight: false,
						},
					},
					interactivity: {
						events: {
							onHover: {
								enable: false // 👈 partículas seguem sua trajetória, sem distrações
							},
							resize: true,
						}
					}
				}}
			/>
			<div className="relative z-10 w-full max-w-5xl flex flex-col gap-12 items-center text-center px-4">
				<div className="flex flex-col items-center text-center space-y-4  md:space-y-6 md:px-0">

					<span className="text-lg sm:text-xl md:text-2xl font-bold text-green-500/90 tracking-tight">
						Grinsper
					</span>

					{/*<h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-semibold text-slate-900 leading-[1.2] tracking-tight max-w-3xl mx-auto">
						Transformamos o comportamento observável de produtos digitais em evidências de <i>Privacy Drift</i>
					</h1>*/}
					<h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-semibold text-slate-900 leading-[1.2] tracking-tight max-w-3xl mx-auto">
						Sorria. Inspire-se. É Grinsper.
					</h1>
					<p className="text-xs md:text-sm text-slate-500 font-medium italic mt-1">
						Novidades em breve nessa metamorfose ambulante.
					</p>

					<div className="mt-10 border-t border-gray-700 pt-6 text-center text-sm text-gray-500">
						© {new Date().getFullYear()} Grinsper. Todos os direitos reservados.
					</div>
				</div>

				{/*<div className="flex flex-col items-center gap-6 w-full max-w-4xl mx-auto px-4">
					<div className="flex flex-col md:flex-row gap-4 w-full justify-center items-center">

						<button
							onClick={() => document.getElementById("grinsper-form")?.scrollIntoView({ behavior: "smooth" })}
							className="order-1 md:order-2 bg-green-600 text-white w-full md:w-auto px-8 py-5 rounded-full text-lg md:text-xl font-bold hover:bg-green-700 hover:scale-105 transition-all shadow-xl active:scale-95 md:whitespace-nowrap"
						>
							Iniciar uma análise
						</button>

						<button
							onClick={() => document.getElementById("grinsper-concept")?.scrollIntoView({ behavior: "smooth" })}
							className="order-2 md:order-1 border-2 border-slate-300 text-slate-600 w-full md:w-auto px-8 py-5 rounded-full text-lg md:text-xl font-semibold hover:border-green-600 hover:text-green-600 hover:bg-green-50 transition-all active:scale-95 md:whitespace-nowrap"
						>
							Saiba mais
						</button>
					</div>

					<p className="text-xs md:text-sm text-slate-500 font-medium italic mt-1">
						Análise inicial gratuita e sob medida para o seu produto.
					</p>
				</div>*/}

			</div>
		</section >
	);
}
